import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Cookie, Settings as SettingsIcon } from 'lucide-react';
import { Button } from '../components/ui/button';
import { appPath } from '../utils/appRouting';

export type CookieBannerProps = {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onCustomize: () => void;
};

export default function CookieBanner(props: CookieBannerProps) {
  const { onAcceptAll, onRejectAll, onCustomize } = props;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[90] p-3 md:p-4"
      role="region"
      aria-label="Informativa cookie"
    >
      <div className="mx-auto w-full max-w-4xl rounded-2xl border border-border bg-card shadow-elev2 overflow-hidden">
        <div className="p-4 md:p-5">
          <div className="flex items-start gap-3">
            <div className="shrink-0 p-2 rounded-lg bg-brand/10 border border-brand/20 text-brand">
              <Cookie className="w-5 h-5" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-foreground">Cookie e privacy</div>
              <div className="text-sm text-muted-foreground mt-1 leading-relaxed">
                Usiamo cookie necessari per il funzionamento della piattaforma. Gli altri
                (analitici, marketing, funzionali) vengono attivati solo con il tuo consenso e
                puoi modificare le preferenze in qualsiasi momento.
              </div>
              <div className="mt-2 text-xs text-muted-foreground">
                <Link
                  to={appPath('/cookie-policy')}
                  className="text-brand hover:underline focus-visible:underline"
                >
                  Cookie Policy
                </Link>
                <span className="mx-1.5 text-muted-foreground/60">·</span>
                <Link
                  to={appPath('/privacy')}
                  className="text-brand hover:underline focus-visible:underline"
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <Button type="button" variant="outline" size="sm" onClick={onRejectAll}>
              <Shield className="w-4 h-4" />
              Rifiuta
            </Button>
            <Button type="button" variant="outline" size="sm" onClick={onCustomize}>
              <SettingsIcon className="w-4 h-4" />
              Personalizza
            </Button>
            <div className="flex-1 hidden sm:block" />
            <Button type="button" size="sm" onClick={onAcceptAll}>
              Accetta tutti
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
